module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-answer"
  }, [_c('ul', {
    staticClass: "has-data"
  }, _vm._l((_vm.questionAswList), function(item, index) {
    return _c('li', {
      key: index,
      class: ("data-item data-item" + (item.id))
    }, [_c('topicContainer', {
      attrs: {
        "userId": _vm.userId,
        "topicInfo": item,
        "topIndex": index,
        "fixedCommentId": _vm.fixedCommentId
      },
      on: {
        "tagSelector": _vm.tagSelector,
        "onApproval": _vm.onApproval,
        "onShowAllComment": _vm.onShowAllComment,
        "focusToggle": _vm.focusToggle
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.questionList.length),
      expression: "questionList.length"
    }],
    staticClass: "load-more"
  }, [(_vm.isLoading) ? _c('img', {
    attrs: {
      "alt": "loading",
      "src": require("../../images/common/loading_2_24x24.gif")
    }
  }) : (Math.ceil(_vm.questionAswList.length / 10) === _vm.listCount) ? _c('p', {
    staticClass: "no-more"
  }, [_vm._v("没有更多问答了")]) : _c('p', {
    on: {
      "click": function($event) {
        return _vm.doLoadMore()
      }
    }
  }, [_vm._v("加载更多")])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-37d2da86!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/topic.vue
// module id = fAoW
// module chunks = 15